/**
 * Created by Mohamed on 5/16/2016.
 */
app.directive('tsMediaViewer', ["hUser", "TSUsersService", "TSMediaViewerService", "TeamScheduleService", function (hUser, TSUsersService, TSMediaViewerService, TeamScheduleService) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: "../modules/team_schedule/common/views/ts_media_viewer_directive.html",
        link: function (scope, element, attrs) {

            scope.users = TSUsersService.users;
            scope.currentImage = 0;
            scope.userComment = {};
            scope.team_user_id = hUser.data.user.team_user_id || hUser.data.user.id;

            $(window).off(".tsMediaViewResize").on("resize.tsMediaViewResize", function() {
                calculateSizes();
                scope.$digest();
            });

            var keyDownHandler = function(event) {

                if (scope.post) {
                    switch (event.keyCode) {
                        case 39: // Right arrow
                        case 38: // Up arrow
                            scope.nextImage(event);
                            break;
                        case 37: // Left arrow
                        case 40: // Down arrow
                            scope.prevImage(event);
                            break;
                        case 27: // Esc
                            scope.closeViewer();
                            break;
                    }

                    scope.$digest();
                }

            };

            /**
             * Init the handlers for keys on keyup event like hide and move between images
             */
            $(document)
                .off('keyup.media-viewer-keydown-pressed')
                .on('keyup.media-viewer-keydown-pressed', keyDownHandler);

            var calculateSizes = function() {

                if (scope.post) {
                    scope.image = scope.post.media[scope.currentImage];

                    var maxWidth = ($(window).width() * 0.9) - 340;
                    var maxHeight = $(window).height() * 0.9;

                    if (maxWidth > 3000) {
                        maxWidth = 3000;
                    }

                    if (maxHeight > 3000) {
                        maxHeight = 3000;
                    }

                    var widthRatio = (maxWidth / scope.image.width);
                    var heightRatio = (maxHeight / scope.image.height);
                    var factor = (widthRatio > heightRatio)? heightRatio: widthRatio;

                    scope.imageWidth = (factor > 1)? scope.image.width: parseInt(factor * scope.image.width);
                    scope.imageHeight = (factor > 1)? scope.image.height: parseInt(factor * scope.image.height);

                    var containerHeight = (scope.imageHeight > 480)? scope.imageHeight: 480;

                    scope.imageMarginTop = (scope.imageHeight < containerHeight)? (containerHeight - scope.imageHeight)/2: 0;

                    scope.imageTop = parseInt(($(window).height() - containerHeight) / 2);
                    $(".ts-media-content").stop().animate({"top": scope.imageTop}, 200);
                }
            };

            TSUsersService.onUsersLoaded(function() {
                scope.$digest();
            });

            TSMediaViewerService.onPostUpdated(function (post, imageIndex) {
                if (post && post.comments) {
                    $(document)
                        .off('keyup.media-viewer-keydown-pressed')
                        .on('keyup.media-viewer-keydown-pressed', keyDownHandler);

                    var postId = post.id;
                    scope.allComments = $.extend({}, post.comments);

                    TeamScheduleService.getActiveBrand()
                        .then(function (brand) {
                            TeamCommunicationAPI.getPostComments(brand.id, postId)
                                .then(function (comments) {
                                        if (scope.post.id == postId) {
                                            scope.allComments.has_more = false;
                                            scope.allComments.list = comments.list;
                                            scope.$digest();
                                        }
                                    },
                                    function (error) {
                                        console.error(error);
                                    });
                        });

                }
                else {
                    $(document).off("keydown");
                }

                scope.post = post;
                scope.image = null;
                scope.currentImage = imageIndex || 0;
                calculateSizes();

            });

            scope.addComment = function($event) {

                if ($event) {

                    if ($event.ctrlKey) {
                        if (scope.userComment.content) {
                            scope.userComment.content += "\r\n";
                        }
                        // If the user clicked enter while clicking Ctrl, do nothing (allow new line)
                        return;
                    }

                    $event.preventDefault();
                }

                var comment = scope.userComment.content;

                if (comment) {
                    comment.trim();
                    scope.userComment.saving = true;

                    TeamScheduleService.getActiveBrand()
                        .then(function(brand) {
                            TeamCommunicationAPI.addCommentToPost(brand.id, scope.post.id, comment)
                                .then(function(commentObj) {
                                    delete scope.userComment.content;
                                    delete scope.userComment.saving;
                                    scope.post.comments.list.splice(0, 0, commentObj);
                                    scope.allComments.list.splice(0, 0, commentObj);
                                    scope.$digest();
                                });
                        });
                }
            }

            scope.nextImage = function($event) {
                $event.preventDefault();
                $event.stopPropagation();
                scope.currentImage = (scope.currentImage + 1) % scope.post.media.length;
                delete scope.image;

                setTimeout(function () {
                    scope.image = scope.post.media[scope.currentImage];
                    calculateSizes();
                    scope.$digest();
                }, 1);
            };

            scope.prevImage = function($event) {
                $event.preventDefault();
                $event.stopPropagation();
                scope.currentImage = (scope.currentImage > 0)? scope.currentImage - 1: scope.post.media.length - 1;
                delete scope.image;

                setTimeout(function () {
                    scope.image = scope.post.media[scope.currentImage];
                    calculateSizes();
                    scope.$digest();
                }, 1);
            };

            scope.closeViewer = function() {
                TSMediaViewerService.close();
            };

			//Destory
			scope.$on('$destroy', function() {
                $(document)
                    .off('keyup.media-viewer-keydown-pressed');

				$(window).off(".tsMediaViewResize");
			});
        }
    }
}]);
